import React from 'react';
import InfoStep from '../components/InfoStep';
import OtpStep from '../components/OtpStep';
import styles from './forsa.module.scss';
import Status from "../components/status";

export function Forsa(props) {
  const {
    step,
    currency,
    handlePaySubmit,
    plans,
    offers,
    loading,
    isDownPayment,
    brandId,
    errorMessage,
    userData,
    customStyle,
    handleOTPResend,
    handleOTPSubmit,
    handleDownPaymentChange,
    handleChangeOffer,
  } = props;
  return (
    <div className={styles['container']} style={customStyle.container}>
      {/*errorMessage && <ErrorMessage errorMessage={errorMessage} />*/}

      {step === 1 && (
        <InfoStep
          plans={plans}
          offers={offers}
          userData={userData}
          isDownPayment={isDownPayment}
          currency={currency}
          loading={loading}
          handleChangeOffer={handleChangeOffer}
          handleDownPaymentChange={handleDownPaymentChange}
          onSubmit={handlePaySubmit}
          customStyle={customStyle}
          brandId={brandId}
        />
      ) }
      {step === 2 &&(
        <OtpStep
          loading={loading}
          handleOTPResend={handleOTPResend}
          handleOTPSubmit={handleOTPSubmit}
          customStyle={customStyle}
        />
      )}
         {step === 3 &&(
        <Status status="success"/>
      )}   {step === 4 &&(
        <Status status="fail"/>
      )}
    </div>
  );
}

export default Forsa;
